<template>

  <v-layout v-if="examinationData" row wrap fill-height justify-center class="pa-4">
    <v-flex xs10 class="pt-0 mt-4">
      <h2 class="examination-info headline font-weight-light mb-4">{{ examinationData.patientName }}</h2>
      <div class="examinationInfoHeader text-uppercase"><span class="font-weight-light">Date</span> {{ examinationData.date }}</div>
      <div class="examinationInfoHeader text-uppercase"><span class="font-weight-light">Examination Record</span> {{ examinationData.accNo }}</div>
      <div class="examinationInfoHeader text-uppercase"><span class="font-weight-light">Medical Record</span> {{ examinationData.medicalRecord }}</div>
      <div class="examinationInfoHeader text-uppercase"><span class="font-weight-light">Date of Birth</span> {{ examinationData.birthday }}</div>
      <div class="examinationInfoHeader text-uppercase"><span class="font-weight-light">Age</span> {{ getAge(examinationData.birthday) }}</div>
      <div class="examinationInfoHeader text-uppercase"><span class="font-weight-light">Gender</span> {{ getGender(examinationData.gender) }}</div>

      <v-layout class="examination-info-form">
        <v-flex xs12>
          <v-select v-model="examinationData.examination_typeID" 
                    label="Examination Type" 
                    :items="getExaminationTypeList" 
                    item-value="id" 
                    item-text="examination_type" 
                    @change="setExaminationColumn('examination_typeID', $event)" hide-details class="mb-3">
          </v-select>
          <v-select v-model="examinationData.inspection_instrumentID" 
                    label="Scope ID" 
                    :items="getInspectionInstrumentList" 
                    item-value="id" 
                    item-text="inspection_instrument" 
                    @change="setExaminationColumn('inspection_instrumentID', $event)" hide-details class="mb-3">
          </v-select>
          <v-select v-model="examinationData.wash_instrumentID" 
                    label="Washing Machine" 
                    :items="getWashInstrumentList" 
                    item-value="id" 
                    item-text="wash_instrument" 
                    @change="setExaminationColumn('wash_instrumentID', $event)" hide-details class="mb-3">
          </v-select>
          <v-select v-model="examinationData.examinationDoctorID" 
                    label="Doctor" 
                    :items="getDoctorList" 
                    item-value="id" 
                    item-text="name" 
                    @change="setExaminationColumn('examinationDoctorID', $event)" hide-details class="mb-4">
          </v-select>
          <v-select v-model="examinationData.technical_staffID_1" 
                    label="Nurse" 
                    :items="getTechnicalStaffList" 
                    item-value="id" 
                    item-text="name" 
                    @change="setExaminationColumn('technical_staffID_1', $event)" hide-details class="mb-4">
          </v-select>
          <v-select v-model="examinationData.technical_staffID_2" 
                    label="Nurse" 
                    :items="getTechnicalStaffList" 
                    item-value="id" 
                    item-text="name" 
                    @change="setExaminationColumn('technical_staffID_2', $event)" hide-details class="mb-3">
          </v-select>
        </v-flex>
      </v-layout>
      
    </v-flex>

    <v-flex id="home-examination-info-buttons" xs12 justify-center class="text-xs-center">
      <v-btn color="primary" @click="goToPage('/examinations', examinationID)">Start Examination</v-btn>
      <v-btn color="secondary" @click="goToPage('/reports', examinationID)">go to report</v-btn>
      <v-btn color="teal" @click="goToReportPreview(examinationID)">Report Preview</v-btn>
    </v-flex>
    
  </v-layout>
  
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import common from '@/utils/common'
  
  export default {
    watch: {
      '$route' (to) {
        this.examinationID = to.params.examinationID
        this.examinationData = this.$store.state.examinations.examinations.find(d => d.id == this.$route.params.examinationID)
      }
    },

    data() {
      return {
        examinationID: this.$route.params.examinationID,
        examinationData : this.$store.state.examinations.examinations.find(d => d.id == this.$route.params.examinationID)
      }
    },

    computed: {
      ...mapGetters('examinations', [
        'getExaminationTypeList', 'getDoctorList', 'getTechnicalStaffList', 'getInspectionInstrumentList', 'getWashInstrumentList'
      ])
    },

    methods: {
      ...mapActions('examinations', ['updateExaminationColumn']),
      goToPage (url, param) {
        this.$router.push(`${url}/${param}/accNo/0`)
      },
      goToReportPreview (examinationID) {
        this.$router.push(`/reports/${examinationID}/accNo/${this.examinationData.accNo}/preview`)
      },
      setExaminationColumn(column, value){
        let d = {
          id: this.examinationID,
          column: column,
          value: value
        }
        this.updateExaminationColumn(d)
      },
      getGender: common.getGender,
      getAge: common.calculageAge
    }
  }
</script>

<style lang="scss" scoped>
  h2 {
    font-size: 20px !important;
    text-transform: capitalize;
  }

  .examinationInfoHeader {
    padding: 4px 0 8px;

    span {
      display: inline-block;
      text-align: left;
      margin-right: 10px;
    }
  }

  .examinationInfoHeader div {
    line-height: 26px;
  }

  .examination-info-form {
    margin: 24px 0 8px;
    padding: 24px 0;
    border-top: 1px solid rgba(0,0,0,0.12);
  }

  #home-examination-info-buttons {
    margin: 24px 0 48px;
    .theme--light.v-btn {
      color: white;
    }
  }

  .headline {
    text-align: center;
  }
</style>